module.exports = __webpack_public_path__ + "img/grants2.9283ab54.jpg";